  import React, { useContext } from "react";
  import { Navigate, useLocation } from "react-router-dom";
  import { AuthContext } from "../context/UserContext";
  import Button from "react-bootstrap/Button";
  import Spinner from "react-bootstrap/Spinner";

  const Privet = ({ children }) => {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();
  
    if (loading) {
      return (
        <Button  className="text-center mt-5" variant="primary" disabled>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
          Loading...
        </Button>
      );
    }

    if (user && user.uid) {
      return children;
    }
    return (
      <Navigate to="/logIn" state={{from : location}} replace></Navigate>
    )
  };

  export default Privet;
